import { useEffect } from 'react';
import { Envs } from '@ae/envs';

export const useVersionLogging = (appName: string) => {
  useEffect(() => {
    const style = 'color: #003f35; background:#eee;  font-size:12px;';
    console.log(`%c🚀 Version ${appName}: ${Envs.version}🚀`, style);
  }, [appName]);
};
